export const INPUT_PLACEHOLDERS = {
  "email": "yourserviceemail@mail.com",
  "password": "*********",
  "phoneNumber": "+15555555555"
}
